import React from "react";
import "react-tech-tree/dist/index.css";
import { ScreenProps } from "../types";
import "./index.css";

function TitleScreen(props: ScreenProps) {
  const dispatcher = (screen: string) => {
    props.dispatch({
      type: "screen/changeScreen",
      payload: { screen }
    });
  };
  return (
    <div id="title-screen">
      <h1>Adrestia: Sublime Balance</h1>
      <button
        type="button"
        className="bit nes-btn is-primary"
        onClick={() => dispatcher("#battle")}
      >
        Endless Mode
      </button>
      <button
        type="button"
        className="bit nes-btn is-primary"
        onClick={() => dispatcher("#multiplayer")}
      >
        Async Multiplayer Mode
      </button>
      <button type="button" className="bit nes-btn is-disabled" disabled>
        Story Mode
      </button>
    </div>
  );
}

export default TitleScreen;
